import { OpenUrlEnum } from '@/types/url-enum'
import { getQueryString, openWindow } from '@/utils/url'
import UaParser from 'ua-parser-js'

export function useUrl() {
  /** 获取跳转url */
  const getToUrl = () => {
    if (getQueryString('toPath')) {
      const uaParser = new UaParser()
      const uaInfo = uaParser.getResult()
      if (
        uaInfo.browser.name === 'WeChat' ||
        uaInfo.browser.name === 'Weibo'
      ) {
        return
      }
      if (uaInfo.os.name === 'Android') {
        openWindow(OpenUrlEnum.GOOGLE_PLAY, { target: '_self' })
      } else if (uaInfo.os.name === 'iOS') {
        openWindow(OpenUrlEnum.IOS_APP_STORE, { target: '_self' })
      }
    }
  }

  return { getToUrl }
}
